import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";
import { CheckCircle, Upload, Circle } from "lucide-react";

interface OnboardingProgressCardProps {
  progress: number;
  onUploadClick: () => void;
}

export function OnboardingProgressCard({ progress, onUploadClick }: OnboardingProgressCardProps) {

  const steps = [
    { id: 1, label: "Profil erstellt", threshold: 33, icon: CheckCircle },
    { id: 2, label: "Foto hochgeladen", threshold: 66, icon: Upload },
    { id: 3, label: "Content generiert", threshold: 100, icon: CheckCircle },
  ];

  return (
    <Card 
      className="bg-gradient-to-br from-green-50 to-emerald-50 dark:from-green-950 dark:to-emerald-950 border-2 border-primary"
      data-testid="card-onboarding-progress"
    >
      <CardContent className="pt-6">
        <div className="flex items-center justify-between mb-5">
          <h3 className="text-lg sm:text-xl font-semibold text-green-900 dark:text-green-100">
            Ihr Fortschritt
          </h3>
          <div className="text-xl sm:text-2xl font-bold text-primary">
            {Math.round(progress)}%
          </div>
        </div>

        <div className="mb-5">
          <Progress 
            value={progress} 
            className="h-2 bg-green-200 dark:bg-green-900" 
            data-testid="progress-onboarding"
          />
        </div>

        <div className="space-y-3 mb-5">
          {steps.map((step) => {
            const isCompleted = progress >= step.threshold;
            const Icon = isCompleted ? CheckCircle : Circle;
            
            return (
              <div 
                key={step.id} 
                className="flex items-center gap-3"
                data-testid={`step-${step.id}`}
              >
                <div className={`w-6 h-6 rounded-full flex items-center justify-center ${
                  isCompleted 
                    ? 'bg-primary text-white' 
                    : 'bg-white dark:bg-green-900 border-2 border-primary text-primary'
                }`}>
                  <Icon className="w-4 h-4" />
                </div>
                <span className={`text-sm font-medium ${
                  isCompleted 
                    ? 'text-green-900 dark:text-green-100' 
                    : 'text-green-700 dark:text-green-300'
                }`}>
                  {step.label}
                </span>
              </div>
            );
          })}
        </div>

        <Button
          onClick={onUploadClick}
          className="w-full min-h-[44px]"
          data-testid="button-upload-photo"
        >
          <Upload className="w-4 h-4 mr-2" aria-hidden="true" />
          {progress >= 66 ? "Weiteres Foto hochladen" : "Jetzt Foto hochladen"}
        </Button>
      </CardContent>
    </Card>
  );
}
